/**
 * IMPORTS
 */
import {focus as focusConversation} from 'src/aggregates/conversations/api';
import {focus as focusCustomer} from 'src/aggregates/customers/api';


/**
 * CODE
 */

/**
 *  I focus the given account, contact, conversation and customer.
 *
 *  :param account: account id
 *  :param contact: contact id
 *  :param conversation: conversation id or null
 *  :param customer: customer id or null
 *
 *  :returns: promise with new uid or null
 */
async function focus (
    account: number,
    contact: string | number,
    conversation: string | number | null,
    customer: string | number | null,
): Promise<void>
{
    // focus given customer
    await focusCustomer(customer);

    // focus given account, contact and conversation
    await focusConversation(account, contact, conversation);
}


/**
 * EXPORTS
 */
export {
    focus,
};
